<template>
  <div>
    <div class="centered-column" v-if="loaded">
      <div class="white-card">
        <div class="white-card-header">
          <div class="title-wrap">
            <label class="title-label">
              {{ label.get("subscription_payment_method") }}</label
            >
          </div>
          <button class="add-new-card add-new-btn" @click="addPaymentMethod">
            <i class="atto atto-add-more" />
            {{ label.get("subscription_add_new_card") }}
          </button>
        </div>
        <div class="payments">
          <div class="list-container">
            <div class="table-heading">
              <span class="heading-title">
                <span class="heading-label name">{{ label.get("name") }}</span>
                <span class="heading-label">{{ label.get("card") }}</span>
              </span>
              <span class="heading-buttons">
                <span class="heading-label primary">{{
                  label.get("primary_card")
                }}</span>
                <span class="heading-label space"></span>
              </span>
            </div>
            <ul class="cards">
              <li v-for="(item, idx) in paymentMethods" :key="idx">
                <div class="cards-owner">
                  <div class="card-type-name">
                    <div class="card-type">
                      <img :src="cardBrandIcon(item.brand)" alt="" />
                    </div>
                    <span class="name">
                      {{ item.card_holder }}
                    </span>
                  </div>
                  <div class="card-info">
                    <span class="name-ending">
                      {{ item.card_holder }}
                    </span>
                    <span class="ending">
                      {{ label.get("subscription_payment_method_card_ending") }}
                      ...{{ item.last4 }}
                    </span>
                  </div>
                </div>
                <div class="payment-cards">
                  <div class="radio-button">
                    <button
                      :disabled="
                        item.pid === defaultPaymentMethod ||
                          disabledDefaultCardButton
                      "
                      :class="{ selected: item.pid === defaultPaymentMethod }"
                      @click="setAsDefaultCard(item)"
                    >
                      <span class="button-text">
                        {{
                          label.get(
                            "subscription_payment_method_use_for_all_feature_payments"
                          )
                        }}
                      </span>
                    </button>
                  </div>
                  <div class="options">
                    <button
                      v-if="item.pid !== defaultPaymentMethod"
                      class="delete-card"
                      @click="deletePaymentMethod(item)"
                    >
                      <i class="atto atto-delete" />
                    </button>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <add-payment-method-component v-if="showAddCard" />
          <delete-payment-method-component v-if="showDeleteCard" :card="card" />
          <default-payment-method-component
            v-if="showDefaultPaymentMethod"
            :card="card"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AddPaymentMethodComponent from "./AddPaymentMethodComponent";
import DeletePaymentMethodComponent from "./DeletePaymentMethodComponent";
import DefaultPaymentMethodComponent from "./DefaultPaymentMethodComponent";
import BillingService from "../services/BillingService";

export default {
  name: "BillingPaymentMethodsComponent",
  components: {
    AddPaymentMethodComponent,
    DeletePaymentMethodComponent,
    DefaultPaymentMethodComponent,
  },
  data() {
    return {
      loaded: false,
      paymentMethods: [],
      defaultPaymentMethod: null,
      selected: 0,
      showAddCard: false,
      showDeleteCard: false,
      card: null,
      disabledDefaultCardButton: false,
      showDefaultPaymentMethod: false,
    };
  },
  created() {
    this.getPaymentMethods();
  },
  mounted() {
    this.$root.$on("hideDeletePaymentMethod", this.hideDeletePaymentMethod);
    this.$root.$on("hideAddPaymentMethod", this.hideAddPaymentMethod);
    this.$root.$on("hideDefaultPaymentMethod", this.hideDefaultPaymentMethod);
  },
  methods: {
    getPaymentMethods() {
      this.$store.commit("showLoading");
      BillingService.getPaymentMethods()
        .then((result) => {
          this.paymentMethods = result.paymentMethods;
          this.defaultPaymentMethod = result.defaultPaymentMethod;
          this.loaded = true;
          this.$store.commit("hideLoading");
        })
        .catch((error) => {
          this.$store.commit("hideLoading");
        });
    },
    cardBrandIcon(brand) {
      if (brand.toUpperCase() === "VISA") {
        return "/assets/images/visa-card.svg";
      }
      if (brand.toUpperCase() === "MATERCARD") {
        return "/assets/images/master-card.svg";
      }
      if (brand.toUpperCase() === "AMERICAN EXPRESS") {
        return "/assets/images/american-express.svg";
      }
      if (brand.toUpperCase() === "DISCOVER") {
        return "/assets/images/discover-card.svg";
      }
      if (brand.toUpperCase() === "DINERS CLUB") {
        return "/assets/images/diners-club-card.svg";
      }
      if (brand.toUpperCase() === "JCB") {
        return "/assets/images/jcb-card.svg";
      }
      return "";
    },

    addPaymentMethod() {
      this.showAddCard = true;
    },

    hideAddPaymentMethod(card) {
      this.showAddCard = false;
      if (card !== undefined && card !== null) {
        this.defaultPaymentMethod = card.pid;
        this.paymentMethods.push(card);
      }
    },

    deletePaymentMethod(card) {
      this.card = card;
      this.showDeleteCard = true;
    },

    hideDeletePaymentMethod(card) {
      if (card !== undefined && card !== null) {
        const idx = this.paymentMethods.indexOf(card);
        this.paymentMethods.splice(idx, 1);
      }
      this.showDeleteCard = false;
      this.card = null;
    },

    setAsDefaultCard(card) {
      if (card.pid === this.defaultPaymentMethod) {
        return;
      }
      this.card = card;
      this.disabledDefaultCardButton = true;
      this.showDefaultPaymentMethod = true;
    },

    hideDefaultPaymentMethod(card) {
      this.showDefaultPaymentMethod = false;
      this.disabledDefaultCardButton = false;
      this.card = null;
      if (card) {
        this.defaultPaymentMethod = card.pid;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
/* @media queries */
@mixin mobile {
  @media (max-width: 480px) {
    @content;
  }
}
/* End of: @media queries */

.white-card {
  .white-card-header {
    width: 100%;
    @include mobile {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      height: auto;
    }
    button {
      @include mobile {
        margin-left: -8px;
        margin-top: 8px;
      }
    }
  }
  .payments {
    width: 100%;
    .list-container {
      display: flex;
      flex-direction: column;
      .table-heading {
        width: 100%;
        display: flex;
        justify-content: space-between;
        @include mobile {
          padding: 0 !important;
        }
        .heading-title,
        .heading-buttons {
          width: 50%;
          span {
            width: 50%;
          }
        }
        .heading-title {
          display: flex;
          justify-content: space-between;
          span {
            @include mobile {
              width: 100%;
              margin-left: 16px;
            }
          }
          .card {
            background: none;
            border: none;
          }
          .name {
            @include mobile {
              display: none;
            }
          }
        }
        .heading-buttons {
          .heading-label {
            @include mobile {
              display: none;
            }
          }
        }
      }
      ul {
        display: flex;
        flex-direction: column;
        width: 100%;
        li {
          display: flex;
          justify-content: space-between;
          position: relative;
          width: 100%;
          padding: 0 8px 0 16px;
          @include mobile {
            flex-direction: column;
            height: auto;
            align-items: flex-start;
            padding: 16px;
          }
          .cards-owner,
          .payment-cards {
            display: flex;
            justify-content: space-between;
            width: 50%;
            @include mobile {
              width: 100%;
            }
            .card-type,
            .card-info,
            .radio-button,
            .option {
              width: 50%;
              @include mobile {
                width: 100%;
              }
            }
          }
          .cards-owner {
            .card-type-name {
              display: flex;
              align-items: center;
              .card-type {
                width: 37px;
                height: 37px;
                border: 1px solid #ebedf0;
                border-radius: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                img {
                  width: 26px;
                  height: 26px;
                }
              }
              .name {
                margin-left: 10px;
                @include mobile {
                  display: none;
                }
              }
            }
            .card-info {
              display: flex;
              align-items: center;
              padding-right: 20px;
              @include mobile {
                flex-direction: column;
                align-items: flex-start;
                margin-left: 12px;
                padding-right: 0;
              }
              .name-ending {
                display: none;
                @include mobile {
                  display: block;
                  text-align: left;
                }
              }
              .ending {
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                text-align: left;
                padding-left: 32px;
                @include mobile {
                  padding-left: 0;
                }
              }
            }
          }
          .payment-cards {
            display: flex;
            align-items: center;
            .radio-button {
              margin-left: -11px;
              display: flex;
              justify-content: center;
              align-items: center;
              @include mobile {
                margin-left: 6px;
                margin-top: 12px;
              }
              button {
                position: relative;
                margin: 0;
                border: 0;
                width: 100%;
                display: flex;
                .button-text {
                  margin-left: 24px;
                  @include mobile {
                    margin-left: 35px;
                  }
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  font-size: 0.8125rem;
                  color: $atto-font-color;
                  text-align: left;
                  text-transform: lowercase;
                  &::first-letter {
                    text-transform: uppercase;
                  }
                }
                &:before {
                  content: "";
                  width: 24px;
                  height: 24px;
                  position: absolute;
                  left: 0;
                  top: 0;
                  border: 1.5px solid #c7c7c7;
                  border-radius: 100%;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                }
                &:after {
                  content: "";
                  width: 12px;
                  height: 12px;
                  border-radius: 100%;
                  background-color: #fff;
                  position: absolute;
                  left: 6px;
                  top: 6px;
                }
                &.selected {
                  &:before {
                    border-color: #00b9cb;
                  }
                  &:after {
                    background-color: #00b9cb;
                  }
                }
              }
            }
            .options {
              display: flex;
              justify-content: flex-end;
              button {
                align-items: center;
                justify-content: center;
                text-align: center;
                background-color: transparent;
                border: 0;
                padding: 0;
                width: 40px;
                height: 40px;
                @include mobile {
                  position: absolute;
                  top: 12px;
                  right: 8px;
                }
                i {
                  display: inline-flex;
                  width: 40px;
                  height: 40px;
                  font-size: 18px;
                  text-align: center;
                  align-items: center;
                  justify-content: center;
                  color: $atto-dark-grey;
                  border-radius: 100%;
                  @include base-transition(ease all 0.15s);

                  &:before {
                    @include base-transition(ease all 0.15s);
                  }
                }
                &:hover {
                  cursor: pointer;
                  i {
                    background-color: $atto-light-grey;
                    &::before {
                      color: $atto-font-color;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
